export { DEFAULT_BRAND_DRAFT, normalizeBranding } from './brandDraft';
export {
  getEffectiveAccent,
  isDefaultBranding,
  isSameBranding,
  isTwoColor,
  resolveBranding,
  withBranding
} from './resolveBranding';
export { buildPreviewVars, getBrandingSummary } from './brandingDisplay';
